// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AnytimeFeedbackAutomationsPage-createWrapper-BMVfj {\n  margin-bottom: 20px;\n}\n.AnytimeFeedbackAutomationsPage-sparkContent-18ZZ_ {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n", ""]);
// Exports
exports.locals = {
	"createWrapper": "AnytimeFeedbackAutomationsPage-createWrapper-BMVfj",
	"sparkContent": "AnytimeFeedbackAutomationsPage-sparkContent-18ZZ_"
};
module.exports = exports;
